/* Checkbox and input validator */ 
let checkbox = document.getElementById('terms_and_contiditons_check');
let input = document.querySelector('.email-signup-banner__box .field input');
let button = document.querySelector('.email-signup-banner__box .field button');
let terms_alert = document.getElementById('terms-and-conditions__alert');

var flag = 0;

if(checkbox){
  validarCheckbox();
  checkbox.addEventListener("change", validarCheckbox, false);
}

function validarCheckbox(){  
  var checked = checkbox.checked;
  if(checked){      
    input.disabled = false;
    button.disabled = false;
    terms_alert.style.display = 'none';
    flag = 1;
  }else{
    button.disabled = true;
    terms_alert.style.display = 'block'; 
    flag = 0;
  }
}

input.addEventListener('input', validarCheckbox, false);

input.addEventListener("keypress", function(event) {
    if (event.key === "Enter" && flag == 0) {
        event.preventDefault();
        terms_alert.style.display = 'block';
    }    
});
